import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useEffect, useState } from 'react';
import { useServices } from './ServiceProvider';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
const AppWideDialogs = () => {
    const { DialogService } = useServices();
    const open = useSelector(DialogService.isDialogOpened);
    const model = useSelector(DialogService.getDialog);
    // Cache the prompt so that it remains for the CSS closing transition
    // once the model is resolved and removed from the store. It will be
    // replaced once a new dialog is opened.
    const [prompt, setPrompt] = useState(model?.prompt);
    useEffect(() => model && setPrompt(model.prompt), [model]);
    return (React.createElement(Dialog, { open: open, onClose: model?.cancel },
        React.createElement(Box, { id: "appwide-dialog" },
            React.createElement(DialogTitle, { id: "appwide-dialog-title" }, model?.prompt),
            React.createElement(DialogActions, null,
                React.createElement(Button, { id: "appwide-dialog-cancel", autoFocus: true, onClick: model?.cancel }, "No"),
                React.createElement(Button, { id: "appwide-dialog-confirm", onClick: model?.confirm }, "Yes")))));
};
export default AppWideDialogs;
//# sourceMappingURL=AppWideDialogs.js.map